<template>
  <div>
    <div class="home-view" v-if="loaded && !empty">
      <section class="-content">
        <div class="container">
          <h1 class="title-default">Status de obra</h1>

          <div class="crono">
            <div class="title">
              <h2>Cronograma<br> geral:</h2>
              <h3>{{ statusExibido.cronogramaGeral }}%</h3>
            </div> <!-- /.title -->

            <div class="content-percents">
              <ul class="percents">
                <li v-for="item of statusEmp" :key="item.key">
                  <h4>Canteiro<br> de obras</h4>
                  <p>{{ statusExibido[item.key] }}%</p>
                </li> <!-- /li -->
              </ul> <!-- /.torres -->
            </div> <!--/.content-percents -->
          </div> <!-- /.crono -->
        </div> <!-- /.container -->
      </section> <!-- /.-content -->

      <section class="emp-gallery -top" v-if="statusExibido.id">
        <div class="container">
          <div class="top-container">
            <div class="tabs">
              <p class="-active" v-if="temFotos">
                <a href="javascript:void(0)" class="name">
                  Empreendimento
                  <span @click="toggleModal">{{ fotosStatus.length }}</span>
                </a>
              </p> <!-- /p -->
            </div> <!-- /.tabs -->
            <div class="status-date">
              <div class="select-month" @click="showDropDown = !showDropDown">
                <h6 class="aligncenter">
                  Fotos de
                  <span class="current-month">{{ statusExibido.mesReferenciaNome }} {{ statusExibido.anoReferencia }}</span>
                </h6>

                <div class="dropdown" @click="showDropDown = !showDropDown" :class="{ '-active': showDropDown }">
                  <a href="javascript:void(0)" @click="loadStatus(item.id)" v-for="(item, i) in dropdown" :key="i">{{ item.mesReferenciaNome }} {{ item.anoReferencia }}</a>
                </div>
              </div> <!-- /.select-month -->
            </div>
          </div> <!-- /.top-container -->
        </div>
      </section>

      <section class="emp-gallery -empty" v-if="statusExibido.id && !temFotos">
        <div class="container">
          <p class="sem-fotos">Sem fotos para este mês</p>
        </div>
      </section> <!-- /.-empty -->

      <section class="slide-status" v-if="temFotos">
        <a href="javascript:void(0)" class="btn-carousel -prev" @click="prevStatus()" :class="{ '-deactivated': activeIndex == 0 }"><i class="icon -arrow-left-red"></i></a>
        <div class="container">
          <swiper ref="swiperStatus" :options="swiperOpts" @slideChange="slideChangedStatus()">
            <template>
              <swiper-slide v-for="(item, i) in fotosStatus" :key="i">
                <figure>
                  <a href="javascript:void(0)" class="icon -zoom-white" @click="toggleModal"></a>

                  <img :src="urlFiles + 'cliente/status-obra/' + item.foto" :alt="item.legenda">
                </figure>
              </swiper-slide>
            </template>
          </swiper>
        </div>

        <a href="javascript:void(0)" class="btn-carousel -next" @click="nextStatus()" :class="{ '-deactivated': activeIndex == fotosStatus.length - 1 }"><i class="icon -arrow-right-red"></i></a>
      </section> <!-- /.slide-status -->

      <section class="emp-gallery" v-if="temFotos">
        <div class="container">
          <div class="bottom-container">
            <ul>
              <li v-for="(item, index) in fotosStatus" :key="item.id" :class="{ '-active': index === activeIndex }" @click="slideToStatus(index)"></li>
            </ul>
          </div>
        </div>
      </section>

      <transition name="fade">
        <Modal :data="optsModal" @close="toggleModal()" v-if="optsModal.render" />
      </transition>
    </div>

    <div class="home-view" v-if="loaded && empty">
      <section class="-content">
        <div class="container">
          <h1 class="title-default">Status de obra</h1>

          <div class="crono">
            <div class="title" style="margin: 0">
              <h2>Nenhum status de obra cadastrado.</h2>
            </div> <!-- /.title -->
          </div> <!-- /.crono -->
        </div> <!-- /.container -->
      </section> <!-- /.-content -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import PagesService from '@/services/Pages'
import Modal from '@/components/Modal'
import { normalizarStatus } from '@/utils/statusObra'

export default {
  name: 'status-obra',

  components: {
    Modal
  },

  data () {
    const data = {
      empty: true,
      loaded: false,

      optsModal: {
        type: 'GALLERY',
        urlBase: 'cliente/status-obra/',
        show: true,
        render: false,
        activeIndex: 0
      },

      model: {
        statusAtual: {}
      },

      dropdown: [],
      empInfo: {},
      statusEmp: [],

      statusId: 0,
      showDropDown: false,

      urlFiles: Vue.prototype.urlFiles,

      activeIndex: 0,
      swiperOpts: {
        autoHeight: true
      },

      status: {
        options: {
          autoHeight: true
        },

        activeIndex: 0
      }, // status

      STATUS_RESID: [
        { title: 'Terraplanagem', key: 'terraplanagem' },
        { title: 'Fundação', key: 'fundacao' },
        { title: 'Estruturas', key: 'estrutura' },
        { title: 'Vedações', key: 'vedacao' },
        { title: 'Instalações', key: 'instalacao' },
        { title: 'Fachada', key: 'fachada' },
        { title: 'Acabamentos', key: 'acabamento' },
        { title: 'Finalização', key: 'finalizacao' }
      ],

      STATUS_CORP: [
        { title: 'Terraplanagem', key: 'terraplanagem' },
        { title: 'Fundação', key: 'fundacao' },
        { title: 'Estruturas', key: 'estrutura' },
        { title: 'Vedações', key: 'vedacao' },
        { title: 'Instalações', key: 'instalacao' },
        { title: 'Fachada', key: 'fachada' },
        { title: 'Acabamentos', key: 'acabamento' },
        { title: 'Finalização', key: 'finalizacao' }
      ],

      STATUS_URBANISMO: [
        { title: 'Terraplanagem', key: 'terraplanagem' },
        { title: 'Rede de drenagem', key: 'redeDrenagem' },
        { title: 'Rede de água potável', key: 'redeAguaPotavel' },
        { title: 'Rede de esgoto', key: 'redeEsgoto' },
        { title: 'Guias e Sarjetas', key: 'guia' },
        { title: 'Pavimentação', key: 'pavimentacao' },
        { title: 'Rede de Iluminação Pública ', key: 'redeIluminacaoPublica' },
        { title: 'Paisagismo e Equipamentos', key: 'paisagismo' },
        { title: 'Calçadas', key: 'calcada' },
        { title: 'Sinalização Vertical e Horizontal', key: 'sinalizacao' },
        { title: 'Finalização', key: 'finalizacao' }
      ]
    }

    return data
  }, // data()

  beforeMount () {
    this.empId = this.$route.params.id
    this.loadList(this.statusId)
  }, // beforeMount()

  mounted () {
  }, // mounted()

  methods: {
    async loadList (statusId) {
      const promises = [PagesService.getStatus(this.empId), PagesService.getStatusDetalhe(this.empId, statusId)]

      return Promise.all(promises).then(res => {
        this.dropdown = res[0]
        this.model = res[1]

        this.optsModal.arr = this.fotosStatus

        this.statusEmp = this.getFields((this.statusExibido.empreendimento || {}).tipo)
        this.loaded = true
        // antes vinha de um TypeError caindo no catch; agora é uma checagem explícita
        this.empty = !this.statusExibido.id
      }).catch(e => {
        this.empty = true
        this.loaded = true
        console.error('Falha ao recuperar status', e)
      })
    }, // loadList()

    getFields (tipo) {
      const obj = {
        residencial: this.STATUS_RESID,
        comercial: this.STATUS_CORP,
        loteamento: this.STATUS_URBANISMO
      }

      return obj[tipo] || []
    }, // getFields()

    async loadStatus (statusId) {
      this.showDropDown = false

      try {
        let xhr = await PagesService.getStatusDetalhe(this.empId, statusId)

        this.model = xhr
        this.empInfo = xhr.empreendimento

        this.activeIndex = 0
        this.optsModal.activeIndex = 0
        this.optsModal.arr = this.fotosStatus
      } catch (e) {
        console.error('Falha ao recuperar status', e)
      }
    }, // loadStatus()

    toggleModal (i) {
      this.optsModal.render = !this.optsModal.render
    }, // toggleModal()

    slideChangedStatus () {
      this.activeIndex = this.swiperStatus.activeIndex
      this.optsModal.activeIndex = this.activeIndex
    }, // slideChangedStatus()

    prevStatus () {
      this.swiperStatus.slidePrev()
    }, // prevStatus()

    nextStatus () {
      this.swiperStatus.slideNext()
    }, // nextStatus()

    isMobile () {
      return screen.width <= 1024
    }, // isMobile()

    slideToStatus (i) {
      this.swiperStatus.slideTo(i)
    } // slideToStatus()
  }, // methods

  computed: {
    // Registro de status realmente exibido — as fotos precisam sair daqui, e não
    // de `fotosRecentes` (que é o último mês COM fotos, nem sempre o mês atual).
    statusExibido () {
      return normalizarStatus(this.model).status
    }, // statusExibido()

    fotosStatus () {
      return normalizarStatus(this.model).fotos
    }, // fotosStatus()

    temFotos () {
      return this.fotosStatus.length > 0
    }, // temFotos()

    swiperStatus () {
      return this.$refs.swiperStatus.swiper
    } // swiperStatus()
  } // computed
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  .main-view
    overflow: hidden

  .main-view.-vibra
    section
      &.-content
        .crono
          .title
            h2
              color: map-get($colors, vibra)

          .percents li h4
            color: map-get($colors, vibra)

      &.slide-status .select-month h6 span.current-month
        background-color: map-get($colors, yellow)

  section
    &.emp-gallery.-empty
      padding: 40px 0 60px

      .sem-fotos
        +box-border
        padding: 40px 20px
        text-align: center
        font-size: 16px
        color: rgba(#666, 0.8)

    &.-content

      .crono
        +box-border
        padding: 40px 70px

        .title
          display: flex
          align-items: center
          justify-content: center
          margin-bottom: 40px
          text-transform: uppercase

          h2
            font-weight: 700
            color: map-get($colors, primary)
            font-size: 20px
            padding-right: 25px
            text-align: right
            position: relative
            top: 5px

          h3
            font-weight: 700
            color: #1d1d1d
            font-size: 80px
            line-height: 60px

        .content-percents
          h3
            width: 100%
            text-align: center
            font-size: 30px

          .percents
            display: flex
            align-items: center
            justify-content: center
            flex-wrap: wrap

            .bar
              height: 10px
              width: 100%
              background-color: map-get($colors, gray)

              .progress
                height: 10px
                width: 0%
                transition: all 2s ease

            &.-nortis
              .bar
                .progress
                  background-color: map-get($colors, primary)

            &.-vibra
              .bar
                .progress
                  background-color: map-get($colors, vibra)

            &.-nortis li
              flex: 0 20%

              &:first-of-type:after,
              &:nth-of-type(6n):after
                display: none

            &.-vibra li
              flex: 0 20%

              &:first-of-type:after,
              &:nth-of-type(6n):after
                display: none

            li
              margin-bottom: 30px
              text-transform: uppercase
              position: relative
              padding: 0 15px

              /*&:last-of-type:after
                display: none*/

              &:after
                content: ''
                width: 1px
                background-color: #ddd
                position: absolute
                top: 5px
                bottom: 5px
                left: calc(100% + 30px)
                left: 0

              h4,
              p
                text-align: center
                display: block

              h4
                color: map-get($colors, primary)
                font-size: 18px
                height: 37px
                display: flex
                align-items: center
                justify-content: center

              p
                color: #1d1d1d
                font-size: 24px
                font-weight: 700

      @media (max-width: 1024px)
        .crono
          padding: 20px 35px

          .title
            flex-direction: column

            h2
              width: 100%
              padding-right: 0
              text-align: center
              font-size: 20px
              margin-bottom: 20px

              br
                display: none

            h3
              font-size: 70px

          .percents
            flex-wrap: wrap
            justify-content: space-between

            li
              width: calc(50% - 10px)
              margin-bottom: 20px
              text-align: center
              margin-bottom: 30px
              flex: 0 47.5%

              &:after
                display: none

              h4
                font-size: 16px

              p
                font-size: 22px
</style>
